import { render, staticRenderFns } from "./Sm500Error.vue?vue&type=template&id=03a4b13a&scoped=true&"
var script = {}
import style0 from "./Sm500Error.vue?vue&type=style&index=0&id=03a4b13a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a4b13a",
  null
  
)

export default component.exports